// ===========================================
// useAuth Hook
// ===========================================
// Hook to access authentication context

import { useContext } from 'react';
import { AuthContext } from './AuthContext.types';

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
